(function () {
  var STORAGE_KEY = 'pl_wishlist';
  var EMAIL_PROMPTED_KEY = 'pl_wishlist_email_prompted';
  var ADD_COUNT_KEY = 'pl_wishlist_add_count';
  var IDENTIFIED_KEY = 'pl_klaviyo_identified';

  function getWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
    updateCountBadges(list.length);
  }

  function isInWishlist(handle) {
    return getWishlist().indexOf(handle) > -1;
  }

  function updateButtonState(btn, handle) {
    var active = isInWishlist(handle);
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
  }

  function updateAllButtons() {
    var buttons = document.querySelectorAll('.js-wishlist-heart');
    for (var i = 0; i < buttons.length; i++) {
      updateButtonState(buttons[i], buttons[i].getAttribute('data-wishlist-handle'));
    }
  }

  function updateCountBadges(count) {
    var counts = document.querySelectorAll('.js-wishlist-count');
    for (var i = 0; i < counts.length; i++) {
      counts[i].textContent = count;
    }

    var dots = document.querySelectorAll('.js-wishlist-dot');
    for (var j = 0; j < dots.length; j++) {
      dots[j].classList.toggle('is-visible', count > 0);
    }

    var fabs = document.querySelectorAll('.WishlistFAB');
    for (var k = 0; k < fabs.length; k++) {
      fabs[k].classList.toggle('is-visible', count > 0);
    }

    var navLinks = document.querySelectorAll('.Header__WishlistNavLink');
    for (var m = 0; m < navLinks.length; m++) {
      navLinks[m].classList.toggle('is-active', count > 0);
    }
  }

  function getCustomer() {
    return window.PLCustomer || {};
  }

  function isLoggedIn() {
    var c = getCustomer();
    return !!(c && c.email);
  }

  function klaviyoIdentify(email) {
    if (!email) return;
    try {
      window._learnq = window._learnq || [];
      window._learnq.push(['identify', { '$email': email }]);
    } catch (e) {}
  }

  function identifyIfLoggedIn() {
    if (!isLoggedIn()) return;
    var email = getCustomer().email;
    try {
      if (sessionStorage.getItem(IDENTIFIED_KEY)) return;
      klaviyoIdentify(email);
      sessionStorage.setItem(IDENTIFIED_KEY, '1');
    } catch (e) {
      klaviyoIdentify(email);
    }
  }

  function trackKlaviyo(eventName, product) {
    try {
      window._learnq = window._learnq || [];
      window._learnq.push(['track', eventName, {
        ProductID: product.id,
        ProductName: product.title,
        ProductHandle: product.handle,
        Price: product.price,
        ImageURL: product.image,
        URL: window.location.origin + '/products/' + product.handle
      }]);
    } catch (e) {}
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str == null ? '' : String(str);
    return div.innerHTML;
  }

  function buildEmailModal() {
    var overlay = document.createElement('div');
    overlay.className = 'WishlistEmailModal';
    overlay.innerHTML =
      '<div class="WishlistEmailModal__Box">' +
        '<button type="button" class="WishlistEmailModal__Close" aria-label="Close">&times;</button>' +
        '<h3 class="WishlistEmailModal__Title Heading u-h3">Don\u2019t lose your favorites</h3>' +
        '<p class="WishlistEmailModal__Text">Add your email and we\u2019ll let you know if a saved piece goes on sale or is running low on stock.</p>' +
        '<form class="WishlistEmailModal__Form" novalidate>' +
          '<input type="email" class="WishlistEmailModal__Input" placeholder="Your email" required>' +
          '<button type="submit" class="WishlistEmailModal__Submit Button Button--primary">Keep me posted</button>' +
        '</form>' +
        '<button type="button" class="WishlistEmailModal__Dismiss">No thanks</button>' +
      '</div>';
    return overlay;
  }

  function dismissEmailModal(overlay) {
    try { localStorage.setItem(EMAIL_PROMPTED_KEY, '1'); } catch (e) {}
    if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
  }

  function showEmailModal() {
    if (document.querySelector('.WishlistEmailModal')) return;

    var overlay = buildEmailModal();
    document.body.appendChild(overlay);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) dismissEmailModal(overlay);
    });

    overlay.querySelector('.WishlistEmailModal__Close').addEventListener('click', function () {
      dismissEmailModal(overlay);
    });

    overlay.querySelector('.WishlistEmailModal__Dismiss').addEventListener('click', function () {
      dismissEmailModal(overlay);
    });

    overlay.querySelector('.WishlistEmailModal__Form').addEventListener('submit', function (e) {
      e.preventDefault();
      var input = overlay.querySelector('.WishlistEmailModal__Input');
      var email = (input.value || '').trim();
      var isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

      if (!isValid) {
        input.classList.add('has-error');
        return;
      }

      klaviyoIdentify(email);

      try {
        window._learnq = window._learnq || [];
        window._learnq.push(['track', 'Wishlist Email Captured', { '$email': email }]);
      } catch (err) {}

      dismissEmailModal(overlay);
    });
  }

  function maybePromptForEmail() {
    if (isLoggedIn()) return;

    try {
      if (localStorage.getItem(EMAIL_PROMPTED_KEY)) return;
    } catch (e) {}

    var count = 1;
    try {
      count = parseInt(sessionStorage.getItem(ADD_COUNT_KEY) || '0', 10) + 1;
      sessionStorage.setItem(ADD_COUNT_KEY, String(count));
    } catch (e) {}

    if (count >= 2) {
      showEmailModal();
    }
  }

  function toggle(btn) {
    var handle = btn.getAttribute('data-wishlist-handle');
    if (!handle) return;

    var list = getWishlist();
    var idx = list.indexOf(handle);
    var nowActive;

    if (idx > -1) {
      list.splice(idx, 1);
      nowActive = false;
    } else {
      list.push(handle);
      nowActive = true;
    }

    saveWishlist(list);
    updateButtonState(btn, handle);

    var productInfo = {
      id: btn.getAttribute('data-wishlist-id') || '',
      title: btn.getAttribute('data-wishlist-title') || '',
      handle: handle,
      price: btn.getAttribute('data-wishlist-price') || '',
      image: btn.getAttribute('data-wishlist-image') || ''
    };

    trackKlaviyo(nowActive ? 'Added to Wishlist' : 'Removed from Wishlist', productInfo);

    if (nowActive) {
      if (isLoggedIn()) {
        identifyIfLoggedIn();
      } else {
        maybePromptForEmail();
      }
    }

    if (document.getElementById('wishlist-page-root')) {
      renderWishlistPage();
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.js-wishlist-heart') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn);
  });

  function groupThousands(intStr, sep) {
    return intStr.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  }

  function formatMoney(cents) {
    var value = Number(cents) / 100;
    if (isNaN(value)) value = 0;

    var moneyFormat = '${{amount}}';
    try {
      if (window.theme && window.theme.moneyFormat) {
        moneyFormat = window.theme.moneyFormat;
      }
    } catch (e) {}

    var fixed = value.toFixed(2);
    var parts = fixed.split('.');
    var hasCents = parts[1] !== '00';

    var formatters = {
      amount_no_decimals_with_comma_separator: function () {
        return groupThousands(String(Math.round(value)), '.');
      },
      amount_with_comma_separator: function () {
        return hasCents
          ? groupThousands(parts[0], '.') + ',' + parts[1]
          : groupThousands(parts[0], '.');
      },
      amount_with_apostrophe_separator: function () {
        return hasCents
          ? groupThousands(parts[0], '\'') + '.' + parts[1]
          : groupThousands(parts[0], '\'');
      },
      amount_no_decimals: function () {
        return String(Math.round(value));
      },
      amount: function () {
        return hasCents ? fixed : parts[0];
      }
    };

    var order = [
      'amount_no_decimals_with_comma_separator',
      'amount_with_comma_separator',
      'amount_with_apostrophe_separator',
      'amount_no_decimals',
      'amount'
    ];

    var result = moneyFormat;
    for (var i = 0; i < order.length; i++) {
      var token = order[i];
      var re = new RegExp('\\{\\{\\s*' + token + '\\s*\\}\\}', 'g');
      if (re.test(result)) {
        result = result.replace(re, formatters[token]());
      }
    }

    return result;
  }

  function heartSvg() {
    return '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.3"><path d="M12 21s-7.5-4.6-10-9.3C.5 8 2 4 6 4c2.2 0 3.7 1.2 4.6 2.4l1.4 1.9 1.4-1.9C14.3 5.2 15.8 4 18 4c4 0 5.5 4 4 7.7-2.5 4.7-10 9.3-10 9.3z"/></svg>';
  }

  function buildCardHtml(product) {
    var variant = product.variants && product.variants[0] ? product.variants[0] : { price: 0 };
    var image = product.featured_image || (product.images && product.images[0]) || '';
    var active = isInWishlist(product.handle);
    return '' +
      '<div class="ProductItem" data-handle="' + product.handle + '">' +
        '<a href="/products/' + product.handle + '">' +
          '<div class="ProductItem__Wrapper">' +
            '<div class="ProductItem__ImageWrapper">' +
              '<button type="button" class="js-wishlist-heart WishlistHeart' + (active ? ' is-active' : '') + '" ' +
                'data-wishlist-handle="' + product.handle + '" ' +
                'data-wishlist-id="' + (product.id || '') + '" ' +
                'data-wishlist-title="' + escapeHtml(product.title) + '" ' +
                'data-wishlist-price="' + variant.price + '" ' +
                'data-wishlist-image="' + image + '" aria-label="' + (active ? 'Remove from wishlist' : 'Add to wishlist') + '">' +
                heartSvg() +
              '</button>' +
              '<img loading="lazy" class="ProductItem__Image" src="' + image + '" alt="' + escapeHtml(product.title) + '">' +
            '</div>' +
            '<div class="ProductItem__Info">' +
              '<h2 class="ProductItem__Title Heading u-h3">' + escapeHtml(product.title) + '</h2>' +
              '<div class="ProductItem__PriceList"><span class="ProductItem__Price Price Heading">' + formatMoney(variant.price) + '</span></div>' +
            '</div>' +
          '</div>' +
        '</a>' +
      '</div>';
  }

  function getSharedHandles() {
    try {
      var params = new URLSearchParams(window.location.search);
      var shared = params.get('share');
      if (!shared) return null;
      return shared.split(',').map(function (h) { return h.trim(); }).filter(Boolean);
    } catch (e) {
      return null;
    }
  }

  function setupShareButton(isViewingSharedList) {
    var btn = document.getElementById('wishlist-share-btn');
    if (!btn) return;

    if (isViewingSharedList || getWishlist().length === 0) {
      btn.style.display = 'none';
      return;
    }

    btn.style.display = '';
    btn.onclick = function () {
      var handles = getWishlist();
      var url = window.location.origin + window.location.pathname + '?share=' + encodeURIComponent(handles.join(','));
      var label = document.getElementById('wishlist-share-btn-label') || btn;

      var done = function () {
        var original = label.textContent;
        label.textContent = 'Link copied!';
        setTimeout(function () { label.textContent = original; }, 2000);
      };

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done).catch(function () {
          window.prompt('Copy this link:', url);
        });
      } else {
        window.prompt('Copy this link:', url);
      }
    };
  }

  function renderListInto(root, list, emptyText, ctaText) {
    if (!root) return;

    if (list.length === 0) {
      root.innerHTML = '<div class="WishlistEmpty"><p>' + escapeHtml(emptyText) + '</p><a href="/collections/all" class="Button Button--primary">' + escapeHtml(ctaText) + '</a></div>';
      return;
    }

    root.innerHTML = '<ul class="WishlistGrid Grid">' +
      list.map(function () {
        return '<li class="Grid__Cell 1/2--phone 1/3--tablet-and-up 1/4--desk WishlistGrid__Placeholder"></li>';
      }).join('') +
      '</ul>';

    var cells = root.querySelectorAll('.WishlistGrid__Placeholder');

    list.forEach(function (handle, i) {
      fetch('/products/' + handle + '.js')
        .then(function (res) {
          if (!res.ok) throw new Error('not found');
          return res.json();
        })
        .then(function (product) {
          if (cells[i]) cells[i].innerHTML = buildCardHtml(product);
        })
        .catch(function () {
          if (cells[i]) cells[i].innerHTML = '';
        });
    });
  }

  function renderWishlistPage() {
    var root = document.getElementById('wishlist-page-root');
    if (!root) return;

    var sharedHandles = getSharedHandles();
    var isViewingSharedList = !!sharedHandles;
    var list = isViewingSharedList ? sharedHandles : getWishlist();

    setupShareButton(isViewingSharedList);

    if (isViewingSharedList) {
      var banner = document.getElementById('wishlist-shared-banner');
      if (banner) banner.style.display = '';
    }

    var emptyText = isViewingSharedList
      ? 'This list is empty.'
      : (root.getAttribute('data-empty-text') || 'Your wishlist is empty.');
    var ctaText = root.getAttribute('data-cta-text') || 'Continue shopping';

    renderListInto(root, list, emptyText, ctaText);
  }

  document.addEventListener('DOMContentLoaded', function () {
    updateAllButtons();
    updateCountBadges(getWishlist().length);
    renderWishlistPage();
    identifyIfLoggedIn();
  });

  window.PLWishlist = {
    getWishlist: getWishlist,
    isInWishlist: isInWishlist
  };
})();
